import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, CheckCircle2 } from 'lucide-react';
export function ProductIntro() {
  const features = ['What supplements to take', 'When to take them', 'Which combinations improve absorption', 'Which combinations should be avoided', 'How to build a better daily routine', 'How to identify high-quality supplements before you buy'];
  return <Section data-id="element-146">
      <div className="text-center mb-12" data-id="element-147">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 text-primary mb-6" data-id="element-148">
          <BookOpen size={32} data-id="element-149" />
        </div>
        <h2 className="text-3xl md:text-5xl font-bold text-primary-dark mb-6" data-id="element-150">
          Introducing the Supplement Blueprint
        </h2>
        <p className="text-xl text-charcoal/80 max-w-2xl mx-auto" data-id="element-151">
          A simple, practical guide that helps you understand:
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-16" data-id="element-152">
        {features.map((feature, i) => <div key={i} className="flex items-center gap-4 bg-white p-6 rounded-xl shadow-sm border border-sage-light/20" data-id="element-153">
            <CheckCircle2 className="text-primary shrink-0" size={24} data-id="element-154" />
            <span className="font-medium text-lg" data-id="element-155">{feature}</span>
          </div>)}
      </div>

      <div className="text-center max-w-3xl mx-auto space-y-6 text-lg text-charcoal/80" data-id="element-156">
        <p data-id="element-157">
          This guide was created for people who want{' '}
          <strong className="text-primary-dark font-semibold" data-id="element-158">
            clarity, simplicity, and better results
          </strong>{' '}
          from the supplements they are already taking — or planning to take.
        </p>
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 pt-8 font-serif text-xl text-primary" data-id="element-159">
          <span data-id="element-160">No confusing medical jargon.</span>
          <span className="hidden md:block w-2 h-2 rounded-full bg-sage" data-id="element-161"></span>
          <span data-id="element-162">No overwhelming science.</span>
        </div>
        <p className="text-2xl font-serif text-primary-dark mt-4" data-id="element-163">
          Just practical guidance you can use right away.
        </p>
      </div>
    </Section>;
}